export default __webpack_public_path__ + "static/media/database.dc4577ed.svg";